export const celsiusToFahrenheit = (celsius: number) => {
  const f = (celsius * 9) / 5 + 32;
  return Math.round(f);
};
